import { __decorate } from "tslib";
import fetchFromCache from '@/utilities/fetchFromCache';
import { Module, VuexModule, MutationAction } from 'vuex-module-decorators';
let Species = class Species extends VuexModule {
    constructor() {
        super(...arguments);
        this.species = [];
        this.cachedVersion = 0;
    }
    async fetchSpecies() {
        const { data: species, cachedVersion } = await fetchFromCache(this, 'species', 'species');
        return { species, cachedVersion };
    }
};
__decorate([
    MutationAction({ mutate: ['species', 'cachedVersion'] })
], Species.prototype, "fetchSpecies", null);
Species = __decorate([
    Module({ namespaced: true, name: 'species' })
], Species);
export default Species;
